import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/service',
  menuFilters: {
    $or: [
      {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
      {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    ],
  },
  children: [
    {
      path: '/reports/service/serviceTimesStatistics',
      name: 'Service Times Statistics',
      meta: { id: 'mc-serviceTimesStatistics', permission: 'mtService' },
      component: () => import('./SpeedOfService.vue'),
      ...addPermissionsToRoute(['mtService']),
      menuFilters: {
        $or: [
          {
            $and: [
              { countryCode: { $in: ['us', 'ca'] } },
              { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
            ],
          },
          {
            $and: [
              { countryCode: { $in: ['za'] } },
              { enterpriseClient: { $eq: 'McDonalds' } },
            ],
          },
        ],
      },
    },
    {
      path: '/reports/timhortons/service/serviceTimes',
      name: 'Service Times',
      meta: { id: 'reports-thServiceTimes', permission: 'mtService' },
      component: () => import('./ServiceTimeStatistics.vue'),
      ...addPermissionsToRoute(['mtService']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
  ],
};

export default routes;
